import { render } from "./ProductPage.vue?vue&type=template&id=42dc5edf&ts=true"
import script from "./ProductPage.vue?vue&type=script&lang=ts"
export * from "./ProductPage.vue?vue&type=script&lang=ts"

import "./ProductPage.vue?vue&type=style&index=0&id=42dc5edf&lang=css"

import exportComponent from "C:\\Paii\\Projects\\TT Exclusive\\ttex_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__